export default "__VITE_ASSET__bce3ff0e__"